import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentPreferencesConfirmationPage from "components/EDEStatements/pages/EDEStatementsEnrollmentPreferencesConfirmationPage";

/**
 * @name CaptureMabiEDEStatementsEnrollmentEmailAddressConfirmation
 * @returns {React.Component}
 * @description A capture in the MABI23 "Statement Preferences (EDE)" capture group.
 */
export default function CaptureMabiEDEStatementsEnrollmentEmailAddressConfirmation(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    return <EDEStatementsEnrollmentPreferencesConfirmationPage />;
}